import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import LocaleThemeProvider from './LocaleThemeProvider';

import App from './App';
import Terms from './Terms';
import Privacy from './Privacy';
import Root from './Root';

const router = createBrowserRouter([
  {
    path: '/terms',
    element: <Root><Terms appName="Lett" /></Root>,
  },
  {
    path: '/privacy',
    element: <Root><Privacy appName="Lett" /></Root>,
  },
  {
    path: '/*',
    element: <Root><App /></Root>,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocaleThemeProvider>
      <RouterProvider router={router} />
    </LocaleThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
